"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "WebhookInvoker", {
    enumerable: true,
    get: function() {
        return WebhookInvoker;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _requestfilteringagent = require("request-filtering-agent");
const _uuid = require("uuid");
const _modelUtils = require("~/utils/modelUtils");
const _ncError = require("~/helpers/ncError");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _webhookHelpers = require("~/helpers/webhookHelpers");
const _Jobs = require("~/interface/Jobs");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _helpers = require("~/services/users/helpers");
const _filtersv3service = require("~/services/v3/filters-v3.service");
const _utils = require("~/utils");
const _apiv3datatransformationbuilder = require("~/utils/api-v3-data-transformation.builder");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let WebhookInvoker = class WebhookInvoker {
    populateAxiosReq({ apiMeta: _apiMeta, hook, model, view, prevData, newData, user }) {
        var _apiMeta_headers;
        if (!_apiMeta) {
            _apiMeta = {};
        }
        const contentType = (_apiMeta_headers = _apiMeta.headers) == null ? void 0 : _apiMeta_headers.find((header)=>{
            var _header_name;
            return ((_header_name = header.name) == null ? void 0 : _header_name.toLowerCase()) === 'content-type' && header.enabled;
        });
        if (!contentType) {
            if (!_apiMeta.headers) {
                _apiMeta.headers = [];
            }
            _apiMeta.headers.push({
                name: 'Content-Type',
                enabled: true,
                value: 'application/json'
            });
        }
        const webhookData = this.constructWebHookData(hook, model, view, prevData, newData, user);
        const apiMeta = _extends({}, _apiMeta);
        // if it's a string try to parse and apply handlebar
        // or if object then convert into JSON string and parse it
        if (apiMeta.body) {
            try {
                apiMeta.body = JSON.parse(typeof apiMeta.body === 'string' ? apiMeta.body : JSON.stringify(apiMeta.body), (_key, value)=>{
                    return typeof value === 'string' ? (0, _webhookHelpers.parseBody)(value, webhookData) : value;
                });
            } catch (e) {
                // if string parsing failed then directly apply the handlebar
                apiMeta.body = (0, _webhookHelpers.parseBody)(apiMeta.body, webhookData);
            }
        }
        if (apiMeta.auth) {
            try {
                apiMeta.auth = JSON.parse(typeof apiMeta.auth === 'string' ? apiMeta.auth : JSON.stringify(apiMeta.auth), (_key, value)=>{
                    return typeof value === 'string' ? (0, _webhookHelpers.parseBody)(value, webhookData) : value;
                });
            } catch (e) {
                apiMeta.auth = (0, _webhookHelpers.parseBody)(apiMeta.auth, webhookData);
            }
        }
        apiMeta.response = {};
        const url = (0, _webhookHelpers.parseBody)(apiMeta.path, webhookData);
        const reqPayload = _extends({
            params: apiMeta.parameters ? apiMeta.parameters.reduce((paramsObj, param)=>{
                if (param.name && param.enabled) {
                    paramsObj[param.name] = (0, _webhookHelpers.parseBody)(param.value, webhookData);
                }
                return paramsObj;
            }, {}) : {},
            url: url,
            method: apiMeta.method,
            data: apiMeta.body,
            headers: apiMeta.headers ? apiMeta.headers.reduce((headersObj, header)=>{
                if (header.name && header.enabled) {
                    headersObj[header.name] = (0, _webhookHelpers.parseBody)(header.value, webhookData);
                }
                return headersObj;
            }, {}) : {},
            withCredentials: true
        }, process.env.NC_ALLOW_LOCAL_HOOKS !== 'true' && !(0, _nocodbsdk.ncIsNullOrUndefined)(url) ? {
            httpAgent: (0, _requestfilteringagent.useAgent)(url),
            httpsAgent: (0, _requestfilteringagent.useAgent)(url)
        } : {}, {
            timeout: 30 * 1000
        });
        return reqPayload;
    }
    constructHookDataForNonURLHooks({ newData, prevData, view, hook, model }) {
        // for old webhooks keep the old data syntax for backward compatibility
        if (hook.version === 'v2' || hook.version === 'v1') {
            return newData;
        } else {
            return this.constructWebHookData(hook, model, view, prevData, newData);
        }
    }
    parseHrtimeToMilliSeconds(hrtime) {
        const milliseconds = (hrtime[0] + hrtime[1] / 1e6).toFixed(3);
        return milliseconds;
    }
    extractResPayloadForLog(response) {
        return {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers,
            data: response.data
        };
    }
    extractReqPayloadForLog(reqPayload, response) {
        var _response_config;
        return _extends({}, reqPayload, {
            headers: _extends({}, (response == null ? void 0 : (_response_config = response.config) == null ? void 0 : _response_config.headers) || {}, reqPayload.headers || {}),
            // exclude http/https agent filters
            httpAgent: undefined,
            httpsAgent: undefined,
            timeout: undefined,
            withCredentials: undefined
        });
    }
    // flatten filter tree and id dummy id if no id is present
    flattenFilter(filters, flattenedFilters = [], parentId = null) {
        for (const filter of filters || []){
            // if parent id is present then set it as fk_parent_id
            if (parentId && !filter.fk_parent_id) {
                filter.fk_parent_id = parentId;
            }
            if (filter.is_group) {
                flattenedFilters.push(filter);
                // this is to group the filters
                if (!filter.id) {
                    filter.id = (0, _uuid.v4)();
                }
                this.flattenFilter(filter.children, flattenedFilters, filter.id);
            } else {
                flattenedFilters.push(filter);
            }
        }
        return flattenedFilters;
    }
    constructWebHookData(hook, model, _view, prevData, newData, user = null) {
        // TODO: construct webhook view data
        if ([
            'v2',
            'v3'
        ].includes(hook.version)) {
            var _parseMetaProp;
            // extend in the future - currently only support records
            const scope = 'records';
            const isBulkInsert = hook.version === 'v2' && hook.operation === 'bulkInsert';
            // Check for include_user in notification object first, fall back to hook.include_user for backward compatibility
            const includeUser = (_parseMetaProp = (0, _modelUtils.parseMetaProp)(hook, 'notification')) == null ? void 0 : _parseMetaProp.include_user;
            return _extends({
                type: `${scope}.${hook.event}.${hook.operation}`,
                id: (0, _uuid.v4)(),
                base_id: model.base_id
            }, includeUser && _utils.isEE && user ? {
                user: (0, _webhookHelpers.sanitizeUserForHook)(user)
            } : {}, {
                version: hook.version,
                data: _extends({
                    table_id: model.id,
                    table_name: model.title
                }, prevData && {
                    previous_rows: Array.isArray(prevData) ? prevData.map((prev)=>_extends({}, prev, {
                            nc_order: undefined
                        })) : [
                        _extends({}, prevData, {
                            nc_order: undefined
                        })
                    ]
                }, !isBulkInsert && newData && {
                    rows: Array.isArray(newData) ? newData.map((each)=>_extends({}, each, {
                            nc_order: undefined
                        })) : [
                        _extends({}, newData, {
                            nc_order: undefined
                        })
                    ]
                }, isBulkInsert && {
                    rows_inserted: Array.isArray(newData) ? newData.length : newData ? 1 : 0
                })
            });
        }
        // for v1, keep it as it is
        return newData;
    }
    async invoke(context, param) {
        const { hook, model, view, user, hookName, prevData, testFilters = null, throwErrorOnFailure = false, testHook = false, ncSiteUrl, addJob } = param;
        let { newData } = param;
        if (hook.version === 'v3' && hookName) {
            // since we already verified the operation in v3,
            // we'll assign the event and operation back to v2 format
            // for it to further be referenced during payload building
            const [event, operation] = hookName.split('.');
            hook.event = event;
            hook.operation = operation.replace('bulk', '').toLowerCase();
        }
        const hookPayload = _extends({}, hook, {
            operation: hook.operation
        });
        let hookLog;
        const startTime = process.hrtime();
        const source = await _models.Source.get(context, model.source_id);
        let notification, filters;
        let reqPayload;
        try {
            notification = typeof hook.notification === 'string' ? JSON.parse(hook.notification) : hook.notification;
            const isBulkOperation = Array.isArray(newData);
            if (isBulkOperation && (notification == null ? void 0 : notification.type) !== 'URL' && (notification == null ? void 0 : notification.type) !== 'Script') {
                // only URL & Script hooks are supported for bulk operations
                return;
            }
            if (hook.condition && !testHook) {
                filters = testFilters || await hook.getFilters(context);
                if (isBulkOperation) {
                    const filteredData = [];
                    for(let i = 0; i < newData.length; i++){
                        const data = newData[i];
                        const pData = prevData[i] ? prevData[i] : null;
                        // if condition is satisfied for prevData then return
                        // if filters are not defined then skip the check
                        if (pData && filters.length && await (0, _webhookHelpers.validateCondition)(context, filters, pData, {
                            client: source == null ? void 0 : source.type
                        })) {
                            continue;
                        }
                        if (await (0, _webhookHelpers.validateCondition)(context, testFilters || await hook.getFilters(context), data, {
                            client: source == null ? void 0 : source.type
                        })) {
                            filteredData.push(data);
                        }
                    }
                    if (!filteredData.length) {
                        return;
                    }
                    newData = filteredData;
                } else {
                    // if condition is satisfied for prevData then return
                    // if filters are not defined then skip the check
                    if (prevData && filters.length && await (0, _webhookHelpers.validateCondition)(context, filters, prevData, {
                        client: source == null ? void 0 : source.type
                    })) {
                        return;
                    }
                    if (!await (0, _webhookHelpers.validateCondition)(context, testFilters || await hook.getFilters(context), newData, {
                        client: source == null ? void 0 : source.type
                    })) {
                        return;
                    }
                }
            }
            // check if form filter applied
            if (notification && notification.trigger_form && notification.trigger_form_id) {
                const formId = notification.trigger_form_id;
                if (view && formId !== view.id) {
                    return;
                }
            }
            switch(notification == null ? void 0 : notification.type){
                case 'Email':
                    {
                        var _notification_payload, _notification_payload1, _notification_payload2, _this;
                        const webhookData = this.constructHookDataForNonURLHooks({
                            hook: hookPayload,
                            model,
                            view,
                            prevData,
                            newData
                        });
                        const parsedPayload = {
                            to: (0, _webhookHelpers.parseBody)(notification == null ? void 0 : (_notification_payload = notification.payload) == null ? void 0 : _notification_payload.to, webhookData),
                            subject: (0, _webhookHelpers.parseBody)(notification == null ? void 0 : (_notification_payload1 = notification.payload) == null ? void 0 : _notification_payload1.subject, webhookData),
                            html: (0, _webhookHelpers.parseBody)(notification == null ? void 0 : (_notification_payload2 = notification.payload) == null ? void 0 : _notification_payload2.body, webhookData)
                        };
                        const res = await ((_this = await _NcPluginMgrv2.default.emailAdapter(false)) == null ? void 0 : _this.mailSend(parsedPayload));
                        if (process.env.NC_AUTOMATION_LOG_LEVEL === 'ALL' || _utils.isEE && !process.env.NC_AUTOMATION_LOG_LEVEL) {
                            hookLog = _extends({}, hook, {
                                operation: hookPayload.operation,
                                fk_hook_id: hook.id,
                                type: notification.type,
                                payload: JSON.stringify(parsedPayload),
                                response: JSON.stringify(res),
                                triggered_by: user == null ? void 0 : user.email,
                                conditions: JSON.stringify(filters)
                            });
                        }
                    }
                    break;
                case 'URL':
                    {
                        reqPayload = this.populateAxiosReq({
                            apiMeta: notification == null ? void 0 : notification.payload,
                            user,
                            hook: hookPayload,
                            model,
                            view,
                            prevData,
                            newData
                        });
                        const { requestPayload, responsePayload } = await (0, _webhookHelpers.handleHttpWebHook)({
                            reqPayload
                        });
                        if (process.env.NC_AUTOMATION_LOG_LEVEL === 'ALL' || _utils.isEE && !process.env.NC_AUTOMATION_LOG_LEVEL) {
                            hookLog = _extends({}, hook, {
                                operation: hookPayload.operation,
                                fk_hook_id: hook.id,
                                type: notification.type,
                                payload: JSON.stringify(requestPayload),
                                response: JSON.stringify(responsePayload),
                                triggered_by: user == null ? void 0 : user.email,
                                conditions: JSON.stringify(filters)
                            });
                        }
                    }
                    break;
                case 'Script':
                    {
                        var _notification_payload3, _notification_payload4, _notification_payload5;
                        const datas = Array.isArray(newData) ? newData : [
                            newData
                        ];
                        const script = await _models.Script.get(context, notification == null ? void 0 : (_notification_payload3 = notification.payload) == null ? void 0 : _notification_payload3.scriptId);
                        if (!script.script || (0, _nocodbsdk.hasInputCalls)(script.script)) {
                            _ncError.NcError.get(context).notImplemented('Script with input calls is not supported');
                        }
                        reqPayload = this.populateAxiosReq({
                            apiMeta: _extends({}, notification == null ? void 0 : notification.payload, {
                                headers: [
                                    {
                                        name: 'nc-script-id',
                                        value: script.id,
                                        enabled: true
                                    },
                                    {
                                        name: 'nc-script-title',
                                        value: script.title,
                                        enabled: true
                                    }
                                ],
                                body: '{{ json event }}'
                            }),
                            user,
                            hook: hookPayload,
                            model,
                            view,
                            prevData,
                            newData
                        });
                        await (addJob == null ? void 0 : addJob(_Jobs.JobTypes.ExecuteAction, {
                            context,
                            scriptId: notification == null ? void 0 : (_notification_payload4 = notification.payload) == null ? void 0 : _notification_payload4.scriptId,
                            modelId: model.id,
                            records: datas,
                            hookPayload: _extends({}, hook, {
                                operation: hookPayload.operation,
                                fk_hook_id: hook.id,
                                type: notification.type,
                                payload: JSON.stringify(this.extractReqPayloadForLog(reqPayload)),
                                triggered_by: user == null ? void 0 : user.email,
                                conditions: JSON.stringify(filters)
                            }),
                            req: {
                                user: _nocodbsdk.NOCO_SERVICE_USERS[_nocodbsdk.ServiceUserType.AUTOMATION_USER],
                                headers: {
                                    'xc-auth': (0, _helpers.genJwt)(_extends({}, _nocodbsdk.NOCO_SERVICE_USERS[_nocodbsdk.ServiceUserType.AUTOMATION_USER], {
                                        extra: {
                                            context: _extends({}, context, {
                                                script_id: notification == null ? void 0 : (_notification_payload5 = notification.payload) == null ? void 0 : _notification_payload5.scriptId
                                            })
                                        }
                                    }), _Noco.default.getConfig(), {
                                        expiresIn: '10m'
                                    })
                                },
                                ncSiteUrl
                            }
                        }));
                    }
                    break;
                default:
                    {
                        var _notification_payload6;
                        const webhookData = this.constructHookDataForNonURLHooks({
                            hook: hookPayload,
                            model,
                            view,
                            prevData,
                            newData
                        });
                        const res = await (await _NcPluginMgrv2.default.webhookNotificationAdapters(notification.type)).sendMessage((0, _webhookHelpers.parseBody)(notification == null ? void 0 : (_notification_payload6 = notification.payload) == null ? void 0 : _notification_payload6.body, webhookData), JSON.parse(JSON.stringify(notification == null ? void 0 : notification.payload), (_key, value)=>{
                            return typeof value === 'string' ? (0, _webhookHelpers.parseBody)(value, webhookData) : value;
                        }));
                        if (process.env.NC_AUTOMATION_LOG_LEVEL === 'ALL' || _utils.isEE && !process.env.NC_AUTOMATION_LOG_LEVEL) {
                            var _hookName_split;
                            hookLog = _extends({}, hook, {
                                operation: hookName == null ? void 0 : (_hookName_split = hookName.split('.')) == null ? void 0 : _hookName_split[1],
                                fk_hook_id: hook.id,
                                type: notification.type,
                                payload: JSON.stringify(notification == null ? void 0 : notification.payload),
                                response: JSON.stringify({
                                    status: res.status,
                                    statusText: res.statusText,
                                    headers: res.headers,
                                    config: {
                                        url: res.config.url,
                                        method: res.config.method,
                                        data: res.config.data,
                                        headers: res.config.headers,
                                        params: res.config.params
                                    }
                                }),
                                triggered_by: user == null ? void 0 : user.email,
                                conditions: JSON.stringify(filters)
                            });
                        }
                    }
                    break;
            }
        } catch (e) {
            if (e.response) {
                var _e_response_config;
                this.logger.error({
                    data: e.response.data,
                    status: e.response.status,
                    url: (_e_response_config = e.response.config) == null ? void 0 : _e_response_config.url,
                    message: e.message
                });
            } else {
                this.logger.error(e.message, e.stack);
            }
            if ([
                'ERROR',
                'ALL'
            ].includes(process.env.NC_AUTOMATION_LOG_LEVEL) || _utils.isEE) {
                var _e_error_code;
                var _hookName_split1;
                hookLog = _extends({}, hook, {
                    operation: hookName == null ? void 0 : (_hookName_split1 = hookName.split('.')) == null ? void 0 : _hookName_split1[1],
                    type: notification.type,
                    payload: JSON.stringify(reqPayload ? this.extractReqPayloadForLog(reqPayload, e.response) : notification == null ? void 0 : notification.payload),
                    fk_hook_id: hook.id,
                    error_code: (_e_error_code = e.error_code) != null ? _e_error_code : e.code,
                    error_message: e.message,
                    error: JSON.stringify(e),
                    triggered_by: user == null ? void 0 : user.email,
                    conditions: filters ? JSON.stringify((0, _filtersv3service.addDummyRootAndNest)((0, _apiv3datatransformationbuilder.filterBuilder)().build(this.flattenFilter(filters)))) : null,
                    response: e.response ? JSON.stringify(this.extractResPayloadForLog(e.response)) : null
                });
            }
            if (throwErrorOnFailure) {
                var _e_code_includes, _e_code, _e_message_includes, _e_message, _e_message_includes1, _e_message1, _e_message_includes2, _e_message2, _e_message_includes3, _e_message3, _e_message_includes4, _e_message4, _e_message_includes5, _e_message5, _e_message_includes6, _e_message6, _e_message_includes7, _e_message7, _e_message_includes8, _e_message8, _e_message_includes9, _e_message9;
                let errorMessage;
                // Check for private IP address blocking
                if (e.isAxiosError) {
                    var _e_response_data_message, _e_response_data, _e_response;
                    if (e.message.includes('private IP address') || ((_e_response = e.response) == null ? void 0 : (_e_response_data = _e_response.data) == null ? void 0 : (_e_response_data_message = _e_response_data.message) == null ? void 0 : _e_response_data_message.includes('private IP address'))) {
                        errorMessage = `Connection to a private network IP is blocked for security reasons.`;
                        if (!_utils.isEE || _utils.isOnPrem) {
                            errorMessage += ` If this is intentional, set NC_ALLOW_LOCAL_HOOKS=true to allow local network webhooks.`;
                        }
                        throw new Error(errorMessage);
                    }
                    // Check for Axios-specific errors
                    if (e.response) {
                        var _e_response_data1, _e_response_data2;
                        // Server responded with error status
                        const status = e.response.status;
                        const statusText = e.response.statusText;
                        const responseMessage = ((_e_response_data1 = e.response.data) == null ? void 0 : _e_response_data1.message) || ((_e_response_data2 = e.response.data) == null ? void 0 : _e_response_data2.error);
                        if (status === 401 || status === 403) {
                            errorMessage = `Authentication failed: ${responseMessage || 'Unauthorized access'}`;
                        } else if (status === 404) {
                            errorMessage = `Endpoint not found: ${reqPayload.url}`;
                        } else if (status === 429) {
                            errorMessage = `Rate limit exceeded: ${responseMessage || 'Too many requests'}`;
                        } else if (status >= 500) {
                            errorMessage = `Server error (${status}): ${responseMessage || statusText || 'Internal server error'}`;
                        } else if (status >= 400) {
                            errorMessage = `Client error (${status}): ${responseMessage || statusText || 'Bad request'}`;
                        } else {
                            errorMessage = `Request failed with status ${status}: ${responseMessage || statusText || 'Unknown error'}`;
                        }
                        throw new Error(errorMessage);
                    } else if (e.request) {
                        // Request was made but no response received
                        errorMessage = `No response received from ${reqPayload.url}: ${e.message || 'Network error'}`;
                        throw new Error(errorMessage);
                    }
                }
                // Check for invalid URL
                if ((e == null ? void 0 : (_e_code = e.code) == null ? void 0 : (_e_code_includes = _e_code.includes) == null ? void 0 : _e_code_includes.call(_e_code, 'ERR_INVALID_URL')) || (e == null ? void 0 : (_e_message = e.message) == null ? void 0 : (_e_message_includes = _e_message.includes) == null ? void 0 : _e_message_includes.call(_e_message, 'Invalid URL'))) {
                    throw new Error(`Invalid URL: ${reqPayload.url}`);
                }
                // Check for DNS resolution errors
                if ((e == null ? void 0 : e.code) === 'ENOTFOUND' || (e == null ? void 0 : e.code) === 'EAI_AGAIN') {
                    throw new Error(`Unable to resolve hostname: ${reqPayload.url} (DNS lookup failed)`);
                }
                // Check for connection errors
                if ((e == null ? void 0 : e.code) === 'ECONNREFUSED') {
                    throw new Error(`Connection refused by ${reqPayload.url} (server not reachable)`);
                }
                if ((e == null ? void 0 : e.code) === 'ECONNRESET') {
                    throw new Error(`Connection was reset by ${reqPayload.url} (network interruption)`);
                }
                if ((e == null ? void 0 : e.code) === 'ECONNABORTED') {
                    throw new Error(`Connection to ${reqPayload.url} was aborted`);
                }
                // Check for timeout errors
                if ((e == null ? void 0 : e.code) === 'ETIMEDOUT' || (e == null ? void 0 : (_e_message1 = e.message) == null ? void 0 : (_e_message_includes1 = _e_message1.includes) == null ? void 0 : _e_message_includes1.call(_e_message1, 'timeout'))) {
                    throw new Error(`Request to ${reqPayload.url} timed out (no response within time limit)`);
                }
                // Check for SSL/TLS certificate errors
                if ((e == null ? void 0 : e.code) === 'CERT_HAS_EXPIRED' || (e == null ? void 0 : e.code) === 'UNABLE_TO_VERIFY_LEAF_SIGNATURE' || (e == null ? void 0 : e.code) === 'SELF_SIGNED_CERT_IN_CHAIN' || (e == null ? void 0 : (_e_message2 = e.message) == null ? void 0 : (_e_message_includes2 = _e_message2.includes) == null ? void 0 : _e_message_includes2.call(_e_message2, 'certificate'))) {
                    throw new Error(`SSL/TLS certificate error for ${reqPayload.url}: ${e.message || 'Invalid certificate'}`);
                }
                // Check for protocol errors
                if ((e == null ? void 0 : e.code) === 'ERR_INVALID_PROTOCOL' || (e == null ? void 0 : (_e_message3 = e.message) == null ? void 0 : (_e_message_includes3 = _e_message3.includes) == null ? void 0 : _e_message_includes3.call(_e_message3, 'Protocol'))) {
                    throw new Error(`Invalid protocol in URL: ${reqPayload.url} (use http:// or https://)`);
                }
                // Check for proxy errors
                if ((e == null ? void 0 : e.code) === 'EPROTO' || (e == null ? void 0 : (_e_message4 = e.message) == null ? void 0 : (_e_message_includes4 = _e_message4.includes) == null ? void 0 : _e_message_includes4.call(_e_message4, 'proxy'))) {
                    throw new Error(`Proxy error when connecting to ${reqPayload.url}`);
                }
                // Check for network unreachable
                if ((e == null ? void 0 : e.code) === 'ENETUNREACH' || (e == null ? void 0 : e.code) === 'EHOSTUNREACH') {
                    throw new Error(`Network unreachable: Cannot connect to ${reqPayload.url}`);
                }
                // Check for too many redirects
                if ((e == null ? void 0 : (_e_message5 = e.message) == null ? void 0 : (_e_message_includes5 = _e_message5.includes) == null ? void 0 : _e_message_includes5.call(_e_message5, 'Maximum redirect')) || (e == null ? void 0 : (_e_message6 = e.message) == null ? void 0 : (_e_message_includes6 = _e_message6.includes) == null ? void 0 : _e_message_includes6.call(_e_message6, 'too many redirects'))) {
                    throw new Error(`Too many redirects when accessing ${reqPayload.url}`);
                }
                // Check for request size errors
                if ((e == null ? void 0 : e.code) === 'ERR_FR_MAX_BODY_LENGTH_EXCEEDED' || (e == null ? void 0 : (_e_message7 = e.message) == null ? void 0 : (_e_message_includes7 = _e_message7.includes) == null ? void 0 : _e_message_includes7.call(_e_message7, 'maxBodyLength'))) {
                    throw new Error(`Request body too large for ${reqPayload.url}`);
                }
                // Check for cancelled requests
                if ((e == null ? void 0 : e.code) === 'ERR_CANCELED' || (e == null ? void 0 : (_e_message8 = e.message) == null ? void 0 : (_e_message_includes8 = _e_message8.includes) == null ? void 0 : _e_message_includes8.call(_e_message8, 'cancel'))) {
                    throw new Error(`Request to ${reqPayload.url} was cancelled`);
                }
                // Check for socket hang up
                if (e == null ? void 0 : (_e_message9 = e.message) == null ? void 0 : (_e_message_includes9 = _e_message9.includes) == null ? void 0 : _e_message_includes9.call(_e_message9, 'socket hang up')) {
                    throw new Error(`Connection lost to ${reqPayload.url} (socket hang up)`);
                }
                // Check for address in use
                if ((e == null ? void 0 : e.code) === 'EADDRINUSE') {
                    throw new Error(`Address already in use when connecting to ${reqPayload.url}`);
                }
                // Check for pipe errors
                if ((e == null ? void 0 : e.code) === 'EPIPE') {
                    throw new Error(`Broken pipe when writing to ${reqPayload.url}`);
                }
                // Fallback: No specific error pattern matched
                errorMessage = (e == null ? void 0 : e.message) || (e == null ? void 0 : e.code) || 'Unknown error occurred';
                // Add the URL context if not already in the message
                if (!errorMessage.includes(reqPayload.url)) {
                    errorMessage = `Request to ${reqPayload.url} failed: ${errorMessage}`;
                }
                // Include error code if available for debugging
                if ((e == null ? void 0 : e.code) && !errorMessage.includes(e.code)) {
                    errorMessage += ` (Error code: ${e.code})`;
                }
                throw new Error(errorMessage);
            }
        } finally{
            if (hookLog) {
                hookLog.execution_time = this.parseHrtimeToMilliSeconds(process.hrtime(startTime));
                _models.HookLog.insert(context, _extends({}, hookLog, {
                    test_call: testHook
                })).catch((e)=>{
                    this.logger.error(e.message, e.stack);
                });
            }
        }
    }
    constructor(){
        this.logger = new _common.Logger(WebhookInvoker.name);
    }
};
